import React from 'react'

function AboutPlanet() {
  return (
    <div>

    
    <div className = 'bg-about h-[90vh] w-full bg-cover bg-no-repeat flex justify-end'>
        <div className='w-full md:w-5/12  justify-center flex flex-col md:mr-20 ml-4 mr-2'>
            <p className='text-cyan-600 text-lg font-bold mb-3'>ABOUT OUR PLANET</p>
            <p className='text-3xl text-white font-bold md:text-4xl mt-2'>We are Creatively <br />
                <span className='text-3xl md:text-4xl text-cyan-600'> Different</span></p>
                <div className='bg-cyan-400 h-1 w-20 ml-20 mt-2 mb-4'></div>
            <p className='text-white'>Accolades, the creative hub in Kerala, keenly takes
                care of too many of internet marketing solutions for your premium brand. 
                Be it the unique designs, Content, Google Ads, SEO Service, Social Media Marketing 
                or other Web  services, Accolades the top digital marketing company in Kerala and 
                Mumbai is in the forefront. We firmly believe  in maximizing your scales, captivate  
                appropriate traffic to your official website, and turn visitors into your potential 
                customers. Regardless of the business’s size, Internet marketing gives access to the 
                mass market at result-oriented pricing, and it inculcates a personal style of
                successful marketing.
            </p>
        </div>
    </div>
    <div className = 'bg-showcase'>

    </div>
    </div>
  )
}

export default AboutPlanet




